/* ClubsDock Ísland – forsíða: mjúk birting við skrun + myndband í hero */
(() => {
  if (window.__cdHome) return;
  window.__cdHome = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.documentElement.classList.add('cd-js');

  /* ---- Birting við skrun ---- */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  const observe = (root) => {
    root.querySelectorAll('.cd-reveal:not(.is-in)').forEach((el) => {
      if (!io || reduce.matches) el.classList.add('is-in');
      else io.observe(el);
    });
  };

  /* ---- Hero-myndband: rétt skrá eftir skjástærð, spilar aðeins þegar sýnilegt ---- */
  const setupVideo = (root) => {
    root.querySelectorAll('video[data-cd-video]').forEach((video) => {
      if (video.dataset.ready) return;
      video.dataset.ready = '1';
      if (reduce.matches) return; // sýnum aðeins poster-mynd

      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const src = (mobile && video.dataset.srcMobile) || video.dataset.srcDesktop;
      if (!src) return;
      video.src = src;
      video.muted = true;

      const vio = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          video.pause();
        }
      }, { threshold: 0.1 });
      vio.observe(video);
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
    });
  };

  const init = (root = document) => { observe(root); setupVideo(root); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* Theme editor: keyra aftur þegar kafli er endurhlaðinn */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
